import {
  Alert,
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFormikContext } from "formik";
import { DisplayFormErrors, DrawerFooterContent } from "melco-shared-logic";
import { CreateMachineLicensesFormValueType } from "./CreateMachineLicensesForm";
import { formatUTCDate } from "../../../../../helper/dateHelper";
import MachineLicensesChangeTable from "./MachineLicensesChangeTable";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type DisplayCreateMachineLicensesSummaryProps = {
  machineLicensesFormValues?: CreateMachineLicensesFormValueType;
  machineLicensesDisplayValues: any;
  stepback: () => void;
  disableCreateAndSendEmailButton: boolean;
};

const { spacings } = DesignTokens;


const StyledOverviewDiv = styled.div`
  margin-top:15px;
`
// const StyledDescriptionsDiv = styled.div`
//   margin-top: 15px;
// `;

// const Label = styled(Text)`
//   display: block;
//   font-family: ${fonts.sansSerifMd};
// `;

export const DisplayCreateMachineLicensesSummary: React.FC<
  DisplayCreateMachineLicensesSummaryProps
> = ({
  stepback,
  machineLicensesFormValues,
  machineLicensesDisplayValues,
  disableCreateAndSendEmailButton,
}) => {
    const { t } = useTranslation();
    const { submitForm } = useFormikContext();
    console.log("machineLicensesFormValues ", JSON.stringify(machineLicensesFormValues))
    console.log("machineLicensesDisplayValues ", JSON.stringify(machineLicensesDisplayValues))
    return (
      <>
        <FullWidthSpace direction="vertical" size="small">
          <DisplayFormErrors />
          <Title level={4}> {t("machinelicenses.create.form.summary")}</Title>
          <Alert
            type="info"
            closable={false}
            message={t("machinelicenses.create.alert.message")}
          />
          <Row gutter={[spacings.middle, 0]}>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                {/* <LabeledItem
                  label={t("machinelicenses.create.form.melco_customer_id")}
                  content={machineLicensesFormValues?.melco_customer_id ?? ""}
                  fallback={t("global.fallback.empty")}
                /> */}
                <LabeledItem
                  label={t("machinelicenses.create.form.license_key")}
                  content={machineLicensesDisplayValues?.license_key ?? ""}
                  fallback={t("global.fallback.empty")}
                />
                <LabeledItem
                  label={t("machinelicenses.create.form.number_of_machines")}
                  content={machineLicensesDisplayValues?.number_of_machines ?? ""}
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
            <Col xs={24} md={6}>
              <Space direction="vertical" size="middle">
                {/* <LabeledItem
                  label={t("machinelicenses.create.form.number_of_machines")}
                  content={machineLicensesDisplayValues?.number_of_machines ?? ""}
                  fallback={t("global.fallback.empty")}
                /> */}
                <LabeledItem
                  label={t("machinelicenses.create.form.subscription_code")}
                  content={machineLicensesDisplayValues?.sub_type ?? ""}
                  fallback={t("global.fallback.empty")}
                />
                <LabeledItem
                  label={t("machinelicenses.create.form.subscription_start_date")}
                  // content={
                  //   dayjs(machineLicensesDisplayValues?.sub_started_on).format(
                  //     "MM/DD/YYYY"
                  //   ) ?? ""
                  // }
                  content={
                    <> {formatUTCDate(machineLicensesDisplayValues?.sub_started_on)}</>
                  }
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
            {/* {
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={"Subscription start date"}
                  content={dayjs(
                    machineLicensesDisplayValues?.subscription_start_date ?? ""
                  ).format("MM/DD/YYYY")}
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
          } */}
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("machinelicenses.create.form.email")}
                  content={machineLicensesFormValues?.email_address ?? ""}
                  fallback={t("global.fallback.empty")}
                />

                <LabeledItem
                  label={t("machinelicenses.create.form.language")}
                  content={machineLicensesDisplayValues?.languageText}
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={24} xl={24}>
              <StyledOverviewDiv>

                <Title level={4}> {t('machinelicenses.create.changetable.account_overview')}</Title>
                <MachineLicensesChangeTable
                  subscription_start_date={formatUTCDate(machineLicensesDisplayValues?.sub_started_on)}
                  response={{
                    monthly: machineLicensesDisplayValues?.monthly,
                    yearly: machineLicensesDisplayValues?.yearly
                  }} />
              </StyledOverviewDiv>
            </Col>
          </Row>  {
            // <StyledDescriptionsDiv>
            //   <Title level={4}>{"License cost"}</Title>
            //   <Descriptions bordered column={1}>
            //     <Descriptions.Item
            //       label={<Text>Subscription start date</Text>}
            //       labelStyle={{ width: "40%", backgroundColor: "#ffffff" }}
            //     >
            //       {" "}
            //       <Text>
            //         {dayjs(machineLicensesDisplayValues?.sub_started_on).format(
            //           "MM/DD/YYYY"
            //         )}
            //       </Text>
            //     </Descriptions.Item>
            //     <Descriptions.Item
            //       label={<Label>Amount of licenses</Label>}
            //       labelStyle={{ width: "40%", backgroundColor: "#ffffff" }}
            //       //contentStyle={{ backgroundColor: "#fafafa" }}
            //     >
            //       <Label>
            //         {machineLicensesDisplayValues?.number_of_machines}{" "}
            //       </Label>
            //     </Descriptions.Item>
            //     <Descriptions.Item
            //       label={<Label>Price per license</Label>}
            //       labelStyle={{ width: "40%", backgroundColor: "#ffffff" }}
            //       //contentStyle={{ backgroundColor: "#fafafa" }}
            //     >
            //       <Label>
            //         {" "}
            //         {"$" +
            //           safeDivide(
            //             machineLicensesDisplayValues?.subscription_cost,
            //             machineLicensesDisplayValues?.license_stats?.totalLicenses
            //           )}
            //         {" / "} {machineLicensesDisplayValues?.sub_type}
            //       </Label>
            //     </Descriptions.Item>
            //     <Descriptions.Item
            //       label={<Label>Total cost</Label>}
            //       labelStyle={{ width: "40%", backgroundColor: "#ffffff" }}
            //       //contentStyle={{ backgroundColor: "#fafafa" }}
            //     >
            //       <Label>
            //         {" "}
            //         {"$" + (machineLicensesDisplayValues?.subscription_cost ?? 0)}
            //         {" / "} {machineLicensesDisplayValues?.sub_type}
            //       </Label>
            //     </Descriptions.Item>
            //   </Descriptions>
            // </StyledDescriptionsDiv>
            // <div>
            //   <Title level={4}>Account overview</Title>
            //   <Title level={5}>Monthly</Title>
            //   <Table
            //     dataSource={monthlyData}
            //     columns={columns}
            //     pagination={false}
            //     bordered
            //   />
            //   <Title level={5} style={{ marginTop: "2rem" }}>
            //     Yearly
            //   </Title>
            //   <Table
            //     dataSource={yearlyData}
            //     columns={columns}
            //     pagination={false}
            //     bordered
            //   />
            // </div>
          }{" "}
        </FullWidthSpace>
        <DrawerFooterContent>
          <Row>
            <Col xs={24} md={12}>
              <Button
                style={{ minWidth: "80px" }}
                key={"back-btn"}
                type="primary"
                onClick={stepback}
              >
                {t("machinelicenses.buttons.back")}
              </Button>
            </Col>
            <Col
              style={{ display: "flex", justifyContent: "flex-end" }}
              xs={24}
              md={12}
            >
              <Right>
                <Button
                  style={{ minWidth: "80px" }}
                  key="add-user-button"
                  type="primary"
                  onClick={() => submitForm()}
                  disabled={disableCreateAndSendEmailButton}
                >
                  {t("machinelicenses.buttons.createsendemail")}
                </Button>
              </Right>
            </Col>
          </Row>
        </DrawerFooterContent>
      </>
    );
  };
